export default __webpack_public_path__ + "static/heartbubble-f54bdc87afd43a543d9970a01752575e.png";